// GENERATED by clinic-management-system/manuals/build-help.mjs -- do not edit.
// The guides' HTML in that folder is the source: correct it there, run the script, and both the
// printed booklet and the Help Centre change together.
//
// Built 2026-10-05 from doctor-guide-english.html, attendance-guide.html, dispenser-invoices-urdu.html, minor-registration-urdu.html.
/* eslint-disable */

// Just enough for the sidebar to know a guide is not the one somebody read last time.
export const HELP_REVISIONS = [
 {
  "id": "doctor",
  "revision": "caa84606ea85"
 },
 {
  "id": "attendance",
  "revision": "46985f9a3131"
 },
 {
  "id": "dispenser",
  "revision": "7478fff472c7"
 },
 {
  "id": "minor",
  "revision": "9eeeacd3544f"
 }
];
